export default {
  allowedMobileOnly: true,
};
